module.exports = __webpack_public_path__ + "img/icon-carspace.f35570ac.svg";